import React from "react";

function Navbar({
  search,
  setSearch,
  filterType,
  setFilterType,
  filterOptions,
  lastUpdated,
}) {

  return (

    <div className="navbar">

      <h1>
        F2B Price Dashboard
      </h1>

      <div className="navbar-right">

        {/* LAST UPDATED CARD */}

        <div className="last-updated-card">

          <span className="updated-title">
            Last Updated
          </span>

          <span className="updated-date">
            {lastUpdated}
          </span>

        </div>

        {/* FILTER TYPE */}

        <select
          value={filterType}
          onChange={(e) =>
            setFilterType(e.target.value)
          }
          className="filter-dropdown"
        >

          <option value="product">
            Product level
          </option>

          <option value="category">
            Category
          </option>

          <option value="subcategory">
            Sub-category
          </option>

        </select>

        {/* SEARCH */}

        {filterType === "product" ? (

          <input
            type="text"
            placeholder="Search product..."
            value={search}
            onChange={(e) =>
              setSearch(e.target.value)
            }
          />

        ) : (

          <select
            value={search}
            onChange={(e) =>
              setSearch(e.target.value)
            }
            className="filter-dropdown"
          >

            <option value="">
              Select {filterType}
            </option>

            {filterOptions.map(
              (option, index) => (

                <option
                  key={index}
                  value={option}
                >
                  {option}
                </option>

              )
            )}

          </select>

        )}

        {/* CLEAR FILTER */}

        <button
          className="clear-filter-btn"
          onClick={() => {
            setSearch("");
            setFilterType("product");
          }}
        >
          Clear Filter
        </button>

      </div>

    </div>
  );
}

export default Navbar;